import React, {Component} from 'react'
import * as config from '../Configuration/Config.js'
import UserProfile from '../Configuration/UserProfile.js';

class MyProfile extends Component {
    constructor() {
        super();

        this.state = {
            is_loaded: false,
            customer_id: null,
            divisions: [],
            id: null,
            user: null
        }
    }

    componentDidMount() {
        
        const p = new UserProfile();
        const user_id = p.UserId();
        const customer_id = p.CustomerId();

        var that = this;
        const uri = config.getUriPath('users/profile/' + user_id)
        console.log(uri);
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {
                that.fetchBusinessDivisions(user_id, data, customer_id );
          });
    }

    fetchBusinessDivisions(user_id, user, customer_id){
        var that = this;
        const uri = config.getUriPath('businessdivisions/all/' + customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {
                that.setState({ is_loaded: true, id: user_id, user: user, customer_id: customer_id, divisions: data });
          });
    }

    render() {
        if (this.state.is_loaded === false) {
            return <div></div>
        }

        const {id, user} = this.state;
        if (!id || !user) {
            return <h1>No user selected</h1>
        }

        if (!user.divisions) {
            user.divisions = [];
        }

        return <div>
                    <div className="center-div">
                        <h1>My Profile</h1>
                    </div>
                    <br />
                    <div className="form-wrapper">
                        <form>
                                <div className="form-group">
                                    <label htmlFor="given_name">First Name:</label>
                                    <input type="text" readOnly="readonly" className="form-control" name="given_name" value={user.given_name}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="family_name">Last Name:</label>
                                    <input type="text" readOnly="readonly" className="form-control" name="family_name" value={user.family_name} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email_address">Email Address:</label>
                                    <input type="email" readOnly="readonly" className="form-control" name="email_address" value={user.email_address} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="title">Title:</label>
                                    <input type="text" readOnly="readonly" className="form-control" name="title" value={user.title} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="department">Department:</label>
                                    <input type="text" readOnly="readonly" className="form-control" name="department" value={user.department} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="security_role">Security Role:</label>
                                    <div>
                                        <select readOnly="readonly" name="security_role" className="form-control" value={user.security_role}>
                                            <option value={config.SecurityRoles.user}>User</option>
                                            <option value={config.SecurityRoles.customerAdmin}>Administrator</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group">
                            <label htmlFor="user_default_link">Home Page Link:</label>
                            <div><input type="text" readOnly="readonly" onChange={this.handleChange} className="form-control" name="user_default_link" defaultValue={user.user_default_link} /></div>
                            <div className="col-md-6 dashboard-roles role-checkboxes">
                                <h3>Business Divisions</h3>
                                <div className="form-group">
                                        {this.state.divisions.map((item) => {
                                            return (
                                                <div className={user.divisions.indexOf(item.id) !== -1 ? "form-check" : "hidden"} key={item.id}>
                                                    {item.business_division_name}
                                                    {/* <input className="form-check-input" type="checkbox" value="" name={item.id} id={item.id} onChange={this.handleChangeDivisions} defaultChecked={user.divisions.indexOf(item.id) !== -1} />
                                                    <label className="form-check-label" htmlFor={item.id}>{item.business_division_name}</label> */}
                                                </div>
                                            )
                                        })}
                                </div>
                            </div>
                        </div>
                        </form>
                    </div>
            </div>
    }
}

export default MyProfile


// WEBPACK FOOTER //
// ./src/Components/User/MyProfile.js